import { motion } from "framer-motion";
import { Element } from "react-scroll";
import { FaArrowRight } from "react-icons/fa";
import { WhatsappLink } from "..";

const MultiBranchSection = () => {
  const branches = [
    {
      name: "Tripoli Branch",
      icon: (
        <span className="flex items-center justify-center text-center w-12 h-12 bg-orange-500 text-white font-bold rounded-md">
          1
        </span>
      ),
      items: 55,
      categories: 11,
      clicks: 1234,
      aiUpSelling : 15
    },
    {
      name: "Beirut Downtown",
      icon: (
        <span className="flex items-center justify-center text-center w-12 h-12 bg-orange-500 text-white font-bold rounded-md">
          2
        </span>
      ),
      items: 42,
      categories: 9,
      clicks: 892,
      aiUpSelling : 12
    },
    {
      name: "Saida Location",
      icon: (
        <span className="flex items-center justify-center text-center w-12 h-12 bg-orange-500 text-white font-bold rounded-md">
          3
        </span>
      ),
      items: 63,
      categories: 13,
      clicks: 2105,
      aiUpSelling : 18
    }
  ];

  return (
    <Element id="multi-branch" name="multi-branch" className="py-20 relative">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Two Column Layout */}
        <div className="grid md:grid-cols-2 gap-16 items-center">
          
          {/* Left: Content */}
            <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex flex-col items-center text-center md:items-start md:text-left"
            >
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-slate-900 leading-tight">
              One Dashboard
              <br />
              <span className="bg-gradient-to-r from-orange-600 to-orange-500 bg-clip-text text-transparent">
              All Your Branches
              </span>
            </h2>
            
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Manage unlimited restaurant locations each with its own dashboard, analytics, and custom menus. Log in, choose a branch, and manage it.
            </p>

            {/* Simple feature list */}
            <div className="space-y-4 mb-8 w-full">
              {[
              "Clone menus to launch new branches in minutes",
              "Compare performance across all locations",
              "Customize AI settings per branch",
              "Switch between branches instantly"
              ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex items-center gap-3"
              >
                <div className="w-2 h-2 bg-orange-500 rounded-full" />
                <span className="text-slate-700">{item}</span>
              </motion.div>
              ))}
            </div>

            <a
              href={WhatsappLink}
              target="_blank"
              className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition-colors"
            >
              See Multi-Branch Demo
              <FaArrowRight />
            </a>  
            </motion.div>

          {/* Right: Branch Cards Stack */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="space-y-4">
              {branches.map((branch, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.15 }}
                  whileHover={{ x: 10 }}
                  className={`bg-white rounded-2xl p-5 border-2 transition-all duration-300 cursor-pointer ${
                    index === 0 
                      ? 'border-orange-400 shadow-lg shadow-orange-500/20' 
                      : 'border-slate-200 hover:border-orange-300'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <span className="text-3xl">{branch.icon}</span>
                      <div>
                        <h3 className="font-bold text-slate-900">{branch.name}</h3>
                        <p className="text-sm text-slate-500">
                          {branch.items} items • {branch.categories} categories
                        </p>
                      </div>
                    </div>
                    <div className="flex space-x-8 text-right">
                      <div >
                      <div className="text-2xl font-bold text-orange-600">
                        {branch.clicks.toLocaleString()}
                      </div>
                      <div className="text-xs text-slate-500">total clicks</div>
                    </div>
                      <div >
                      <div className="text-2xl font-bold text-orange-600">
                        {branch.aiUpSelling.toLocaleString() }%
                      </div>
                      <div className="text-xs text-slate-500">AI Upselling</div>
                    </div>
                    </div>
                    
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Subtle decoration */}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-orange-100 rounded-full blur-3xl opacity-50" />
          </motion.div>
        </div>
      </div>
    </Element>
  );
};

export default MultiBranchSection;
